/**
 * @file - Uber authorize component.
 */

import { Component, OnInit } from '@angular/core';
import {isReferredByUberPartner, resetUserToken, startUserSessionMonitor} from "../../shared/utitlity-functions/utility-functions";
import { JoinService } from '../../core/services/join/join.service';
import {BehaviorSubject, Subscription} from "rxjs";
import { environment } from '../../../environments/environment';
import { FunnelGuardSyncService } from '../../core/services/driver/funnel-guard-sync.service';

/**
 *
 */
@Component({
    standalone: false,
    selector: 'uber-connect-required',
    templateUrl: './uber-connect-required.component.html',
    styleUrls: ['./uber-connect-required.component.scss']
})
export class UberConnectRequiredComponent implements OnInit {

    /**
     * Constructor.
     *
     */
    userData$ = new Subscription();
    user: any;
    status: any;
    uberConnectStatus: string = '';
    uberConnectFlag: boolean = environment.UBER_CONNECT_SIGNUP_FLAG;
    isUberConnected$ = new BehaviorSubject<boolean | null>(null);
    isReferredByUberPartner$ = new BehaviorSubject<boolean>(false);
    hasData: boolean = false;


    constructor(
        private readonly joinService: JoinService,
        private readonly funnelGuardSyncService: FunnelGuardSyncService
    ) {}


    ngOnInit() : void {
        this.hasData = false;    
        resetUserToken();
        startUserSessionMonitor();
        this.userData$ = this.joinService.getUserData().subscribe((data: any) => {
            this.user = data;
            this.uberConnectStatus = data?.uber_connect ? data.uber_connect.status : 'n/a';
            this.isUberConnected$.next(!data?.allow_uber_connection);
            this.isReferredByUberPartner$.next(isReferredByUberPartner(data?.referral_info?.referred_by));
            let val: any = {};
            if (!this.user?.driver_info.preferred_name) {
                val.preferred_name = this.user?.first_name;
            }
            this.hasData = !!data;
            this.funnelGuardSyncService.setFunnelGuardSync(true);
        });
    }
}
